// 分身商后台菜单工具
//
// 菜单的唯一权威来源是后端：后端按当前账号的角色权限过滤后返回 menus
// （未分配角色的超级管理员由后端返回全部菜单）。
// 这里的 defaultMenus 仅作为「超级管理员」在接口异常时的安全网，
// 普通角色（例如角色权限里没有勾选「首页数据」）绝不能用它兜底，
// 否则无权限的账号依然会看到首页等全部菜单。

export const defaultMenus = [
  { id: 1, name: '首页数据', path: '/dashboard', icon: 'el-icon-s-data' },
  { id: 2, name: '普惠商品管理', path: '/products', icon: 'el-icon-goods' },
  { id: 3, name: '商品审核', path: '/review', icon: 'el-icon-document-checked' },
  { id: 41, name: '普惠订单', path: '/orders/puhui', icon: 'el-icon-s-order' },
  { id: 42, name: '甄选/爆品订单', path: '/orders/report', icon: 'el-icon-tickets' },
  { id: 5, name: '全平台会员', path: '/members', icon: 'el-icon-user-solid' },
  { id: 6, name: '分身账号管理', path: '/accounts', icon: 'el-icon-key' },
  { id: 7, name: '平台财务', path: '/finance', icon: 'el-icon-money' },
  { id: 8, name: '龙虎榜', path: '/leaderboard', icon: 'el-icon-trophy' },
  { id: 9, name: '会员商户信息审核', path: '/merchant-audit', icon: 'el-icon-s-check' },
  { id: 10, name: '托管商品管理', path: '/cloud-warehouse', icon: 'el-icon-box' },
  { id: 12, name: '可委托公司管理', path: '/delegated-companies', icon: 'el-icon-office-building' },
  { id: 13, name: '委托账户', path: '/delegated-accounts', icon: 'el-icon-coin' },
  { id: 14, name: '供货商管理', path: '/distributors', icon: 'el-icon-s-cooperation' },
  {
    id: 11,
    name: '系统管理',
    path: '/system',
    icon: 'el-icon-setting',
    children: [
      { id: 111, name: '管理员管理', path: '/system/admins', icon: 'el-icon-user' },
      { id: 112, name: '角色管理', path: '/system/roles', icon: 'el-icon-s-custom' },
      { id: 113, name: '权限管理', path: '/system/permissions', icon: 'el-icon-lock' },
      { id: 114, name: '系统配置', path: '/system/config', icon: 'el-icon-setting' }
    ]
  }
]

/**
 * 决定实际渲染的菜单
 * @param {Array} menus 后端返回的菜单
 * @param {Boolean} isSuper 是否未分配角色的超级管理员
 */
export function normalizeMenus(menus, isSuper) {
  if (menus && menus.length > 0) {
    return menus
  }
  return isSuper ? defaultMenus : []
}

/**
 * 深度优先取第一个有权限的菜单路径
 *
 * 用于「登录成功后」和「访问根路径」时的落地页：
 * 不能再固定跳 /dashboard，否则角色权限里没有「首页数据」也会直接进首页。
 *
 * @param {Array} menus 后端返回的菜单
 * @param {Boolean} isSuper 是否未分配角色的超级管理员
 * @returns {String} 路径，没有可访问菜单时返回空串
 */
export function firstAccessiblePath(menus, isSuper) {
  const walk = (nodes) => {
    let result = ''
    ;(nodes || []).forEach((node) => {
      if (result) return
      if (node.children && node.children.length > 0) {
        result = walk(node.children)
      }
      if (!result && node.path) {
        result = node.path
      }
    })
    return result
  }

  return walk(normalizeMenus(menus, isSuper))
}
